/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetBudgetDto } from './GetBudgetDto';
import {
    GetBudgetDtoFromJSON,
    GetBudgetDtoFromJSONTyped,
    GetBudgetDtoToJSON,
} from './GetBudgetDto';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetDownloadsDocumentsDto
 */
export interface GetDownloadsDocumentsDto {
    /**
     * 
     * @type {string}
     * @memberof GetDownloadsDocumentsDto
     */
    id: string;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetDownloadsDocumentsDto
     */
    project: GetProjectDto;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetDownloadsDocumentsDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetDownloadsDocumentsDto
     */
    team: GetTeamDto;
    /**
     * 
     * @type {GetBudgetDto}
     * @memberof GetDownloadsDocumentsDto
     */
    budget: GetBudgetDto;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetDownloadsDocumentsDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {string}
     * @memberof GetDownloadsDocumentsDto
     */
    yearType: GetDownloadsDocumentsDtoYearTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof GetDownloadsDocumentsDto
     */
    rangeMonthFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetDownloadsDocumentsDto
     */
    rangeMonthTo?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDownloadsDocumentsDto
     */
    salesInvoices: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDownloadsDocumentsDto
     */
    salesInvoicesCopies: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDownloadsDocumentsDto
     */
    purchaseInvoices: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDownloadsDocumentsDto
     */
    contracts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDownloadsDocumentsDto
     */
    projectAttachments: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDownloadsDocumentsDto
     */
    attachmentsTypesIds?: Array<string>;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetDownloadsDocumentsDto
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetDownloadsDocumentsDto
     */
    creationTs: Date;
    /**
     * 
     * @type {boolean}
     * @memberof GetDownloadsDocumentsDto
     */
    status?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetDownloadsDocumentsDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDownloadsDocumentsDto
     */
    info?: string | null;
}


/**
 * @export
 */
export const GetDownloadsDocumentsDtoYearTypeEnum = {
    DateOfIssue: 'DateOfIssue',
    DateOfSale: 'DateOfSale',
    DateOfProject: 'DateOfProject'
} as const;
export type GetDownloadsDocumentsDtoYearTypeEnum = typeof GetDownloadsDocumentsDtoYearTypeEnum[keyof typeof GetDownloadsDocumentsDtoYearTypeEnum];


/**
 * Check if a given object implements the GetDownloadsDocumentsDto interface.
 */
export function instanceOfGetDownloadsDocumentsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "project" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "budget" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "yearType" in value;
    isInstance = isInstance && "salesInvoices" in value;
    isInstance = isInstance && "salesInvoicesCopies" in value;
    isInstance = isInstance && "purchaseInvoices" in value;
    isInstance = isInstance && "contracts" in value;
    isInstance = isInstance && "projectAttachments" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "creationTs" in value;

    return isInstance;
}

export function GetDownloadsDocumentsDtoFromJSON(json: any): GetDownloadsDocumentsDto {
    return GetDownloadsDocumentsDtoFromJSONTyped(json, false);
}

export function GetDownloadsDocumentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDownloadsDocumentsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'project': GetProjectDtoFromJSON(json['project']),
        'company': GetCompanyDtoFromJSON(json['company']),
        'team': GetTeamDtoFromJSON(json['team']),
        'budget': GetBudgetDtoFromJSON(json['budget']),
        'client': GetClientDtoFromJSON(json['client']),
        'yearType': json['yearType'],
        'rangeMonthFrom': !exists(json, 'rangeMonthFrom') ? undefined : (json['rangeMonthFrom'] === null ? null : new Date(json['rangeMonthFrom'])),
        'rangeMonthTo': !exists(json, 'rangeMonthTo') ? undefined : (json['rangeMonthTo'] === null ? null : new Date(json['rangeMonthTo'])),
        'salesInvoices': json['salesInvoices'],
        'salesInvoicesCopies': json['salesInvoicesCopies'],
        'purchaseInvoices': json['purchaseInvoices'],
        'contracts': json['contracts'],
        'projectAttachments': json['projectAttachments'],
        'attachmentsTypesIds': !exists(json, 'attachmentsTypesIds') ? undefined : json['attachmentsTypesIds'],
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': (new Date(json['creationTs'])),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'info': !exists(json, 'info') ? undefined : json['info'],
    };
}

export function GetDownloadsDocumentsDtoToJSON(value?: GetDownloadsDocumentsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'project': GetProjectDtoToJSON(value.project),
        'company': GetCompanyDtoToJSON(value.company),
        'team': GetTeamDtoToJSON(value.team),
        'budget': GetBudgetDtoToJSON(value.budget),
        'client': GetClientDtoToJSON(value.client),
        'yearType': value.yearType,
        'rangeMonthFrom': value.rangeMonthFrom === undefined ? undefined : (value.rangeMonthFrom === null ? null : value.rangeMonthFrom.toISOString()),
        'rangeMonthTo': value.rangeMonthTo === undefined ? undefined : (value.rangeMonthTo === null ? null : value.rangeMonthTo.toISOString()),
        'salesInvoices': value.salesInvoices,
        'salesInvoicesCopies': value.salesInvoicesCopies,
        'purchaseInvoices': value.purchaseInvoices,
        'contracts': value.contracts,
        'projectAttachments': value.projectAttachments,
        'attachmentsTypesIds': value.attachmentsTypesIds,
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': (value.creationTs.toISOString()),
        'status': value.status,
        'fileName': value.fileName,
        'info': value.info,
    };
}

